/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import {
  CONFIG_ERROR,
  RECEIVED_CONFIG_FILE,
  REQUESTED_CONFIG
} from './ConfigActions';

export const CONFIG_INITIAL_STATE = {
  isLoading: false,
  hasError: false,
  apiKey: '',
  environment: null,
  version: ''
};

export const configReducer = (state = CONFIG_INITIAL_STATE, action) => {
  // TODO : support error state

  if (action.type === RECEIVED_CONFIG_FILE) {
    const { apiKey, environment, version } = action.config;
    return {
      ...state,
      isLoading: false,
      hasError: false,
      apiKey,
      environment,
      version
    };
  }
  if (action.type === CONFIG_ERROR) {
    return {
      ...state,
      hasError: true,
      isLoading: false
    };
  }
  if (action.type === REQUESTED_CONFIG) {
    return {
      ...state,
      isLoading: true
    };
  }
  return state;
};
